import Vue from "vue";
import VueRouter from "vue-router";
import { getToken } from "../utils/util.js";
Vue.use(VueRouter);
const routes = [

  // 首页
  {
    path: "/",
    name: "Index",
    component: () => import("../views/Index.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/competition",
    name: "Tournament",
    component: () => import("../views/Tournament.vue"),
  },
  {
    path: "/product",
    name: "Product",
    component: () => import("../views/Product.vue"),
  },
  {
    path: "/detail",
    name: "Detail",
    component: () => import("../views/Detail.vue"),
  },
  {
    path: "/practice",
    name: "Practice",
    component: () => import("../views/Practice.vue"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue"),
  },
  {
    path: "/news/detail",
    name: "News-detail",
    component: () => import("../views/News-detail.vue"),
  },
  {
    path: "/activity",
    name: "Activity",
    component: () => import("../views/Activity.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
  },
  {
    path: "/tournament-info",
    name: "Tournament-info",
    component: () => import("../views/Tournament-info.vue"),
  },
  {
    path: "/event",
    name: "Event",
    component: () => import("../views/Event.vue"),
  },
];
const router = new VueRouter({
  routes,
});

// 全局路由守卫
// router.beforeEach((to, from, next) => {
//   const token = getToken();
//   console.log(token);

//   // 判断是否进入/chat路由
//   if (to.path === "/chat" || to.path.includes("/user")) {
//     if (!token) {
//       // 没有token，提示并跳转到登录页
//       next({
//         path: "/login",
//       });
//       return;
//     }
//   }

//   next();
// });
// 核心代码：路由切换后滚动到顶部
router.afterEach((to, from) => {
  // 滚动到页面顶部，{ behavior: 'smooth' } 可选，实现平滑滚动
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // 去掉则是瞬间回到顶部
  });
});
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err);
};

export default router;
